<template>
  <user-center-wrap>
    <centerHeader />
    <div class="my-wallet-panel">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="消费明细" name="consumer">
          <Consumer ref="consumer"></Consumer>
        </el-tab-pane>
        <el-tab-pane label="收入明细" name="income">
          <Income ref="income"></Income>
        </el-tab-pane>
        <!-- <el-tab-pane label="提现明细" name="withdrawal">
          <Withdrawal ref="widthdrawal"></Withdrawal>
        </el-tab-pane>
        <el-tab-pane label="我的银行卡" name="bankcard">
          <Bankcard ref="bankcard"></Bankcard>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </user-center-wrap>
</template>

<script>
import UserCenterWrap from "../../components/user-center-wrap/user-center-wrap";
// import LiveItem from "../../components/live-item/live-item";
import CenterHeader from "../../components/child/centerHeader";
import Consumer from "../../components/child/consumer";
import Income from "../../components/child/income";
import Withdrawal from "../../components/child/withdrawal";
import Bankcard from "../../components/child/bankcard";
import { post } from "../../util/http";
import { h5Host } from "../../util/host";
import getPlatform from "../../util/platform";
import bankcardVue from "../../components/child/bankcard.vue";

const PAGE_SIZE = 9;

export default {
  async asyncData({ req, redirect }) {
    if (req && process.server && getPlatform(req) === "h5") {
      redirect(h5Host + "/user-center/focus");
    }
  },
  // middleware: "login-check",
  components: {
    UserCenterWrap,
    CenterHeader,
    Consumer,
    Income,
    Withdrawal,
    Bankcard,
  },
  data() {
    return {
      activeName: "consumer",
    };
  },
  mounted() {
    if (this.$route.query.bank) {
      this.activeName = "bankcard";
    }
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
      if (tab.$children[0] && tab.$children[0].getListInfo) {
        tab.$children[0].getListInfo();
      }
    },
  },
};
</script>

<style lang="stylus">
// @import '../../assets/variable.styl';
.dateTimer-droper{
  border : 0px !important;
  margin-top : 6px;
  .popper__arrow{
    display : none;
  }
  .el-date-table td.start-date span, .el-date-table td.end-date span{
    background-color : #02A8A2;
    color : #ffffff !important;
  }
  .el-date-table td.today span{
    color : #02A8A2;
  }
}

.my-wallet-panel{
  padding : 10px 35px;
  .select-btn{
    border : none;
    font-size: 16px;
    color: #fff !important;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    border-radius: 18px;
    padding: 8px 38px;
    background: #02A8A2 !important;
    &:hover{
      background: #02A8A2;
      border:none;
      color: #fff;
    }
  }
  .el-form-item{
    padding-right : 20px;
  }
  .search_condition{
    margin : 20px 0px;
  }
  .el-table{
    border-top-left-radius : 8px;
    border-top-right-radius : 8px;
  }

    .el-tabs__item{
      font-size: 18px;
      color: #666666;
      letter-spacing: 0;
      font-weight: 400;
      padding: 0 ;
      margin-right 40px;
    }
    .el-tabs__item.is-active,.el-tabs__item:hover{
      color:  #02A8A2;
      position: relative;
        &:before{
        content: "";
        position: absolute;
        bottom : 0;
        left : 50%;
        transform: translateX(-50%);
        width: 20px;
        height: 4px;
        background: #02A8A2;
        border-radius: 100px;
      }
    }
    .el-tabs__active-bar{
      height : 0px;
    }
    .el-tabs__nav-wrap::after{
      height : 1px;
    }

    .popper__arrow{
      display : none;
    }
    .el-popper{
      left : 0px;
      border : 0px !important;
      // top: 24px !important;
       margin-top : 6px !important;
    }
    .el-icon-arrow-up:before{
      content: ""
      color : #000000;
      transform : rotate(180deg);
      display:block;
    }
    .el-icon-date{
      right : 19px;
      top:5px;
      position: absolute;
      &:before{
        content: "";
        background-image:url(../../assets/img/child/share_rili.png);
        background-size : 100% auto;
        display: block;
        width : 24px;
        height : 24px;
      }
    }
    .el-range__close-icon{
      z-index :20000;
      display: block;
      right: 0px;
      top: 2px;
      position: absolute;
    }

    .el-form-item__label{
      line-height : 38px;
    }
    .el-input--suffix .el-input__inner{
      background: #F7F7F7;
    }
    .el-input__inner{
      border-color : #f0f0f0 !important;
      //color : #333333 !important;
      &:hover{
        border-color : #f0f0f0 !important;
      }
    }
    .el-select .el-input.is-focus .el-input__inner{
      border-color : #f0f0f0;
    }
    .el-select .el-input__inner:focus{
      border-color : #f0f0f0;
    }
    .el-range-input {
      background: #f7f7f7 !important;
      //color: #333333 !important;
    }
    .el-date-editor {
      border-color : #f0f0f0 !important;
      background: #f7f7f7 !important;
    }
    .el-date-table td.start-date span, .el-date-table td.end-date span{
      // background-color : #02A8A2 !important;
    }
    .el-input__inner{
      background: #f7f7f7 !important;
      border-color : #f0f0f0;
      //color : #333333;
    }
    .el-input__inner:focus{
      border-color : #f0f0f0;
    }
    .el-select-dropdown__item{
      text-align : center;
    }
    .el-select-dropdown__item.selected,.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
      background-color : rgba(38,217,157,0.10);
      color: #333333;
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active{
      background-color : #02A8A2;
    }


  .pagination_bottom{
    padding : 10px;
    display : flex;
    justify-content : center;
  }

}
</style>
